
export default {
  props: ['provinces', 'searchTypeData', 'provinceId', 'searchType'],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      searchInput: ''
    }
  },
  methods: {
    handleSearchTypeChange(value) {
      this.$emit('handleSearchTypeChange', value)
    },
    handleSearch() {
      this.$emit('handleSearch', this.searchInput)
    },
    handleFilterLocation(value) {
      this.$emit('handleFilterLocation', value)
    }
  }
}
